import { render, staticRenderFns } from "./TenancyView.vue?vue&type=template&id=4a268b74&scoped=true&"
import script from "./TenancyView.vue?vue&type=script&lang=js&"
export * from "./TenancyView.vue?vue&type=script&lang=js&"
import style0 from "./TenancyView.vue?vue&type=style&index=0&id=4a268b74&lang=scss&scoped=true&"
import style1 from "./TenancyView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a268b74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a268b74')) {
      api.createRecord('4a268b74', component.options)
    } else {
      api.reload('4a268b74', component.options)
    }
    module.hot.accept("./TenancyView.vue?vue&type=template&id=4a268b74&scoped=true&", function () {
      api.rerender('4a268b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/TenancyView.vue"
export default component.exports